import { useEffect, useState } from "react";
import { FAQS } from "@/mocks/gossip";
import Header from "./components/Header";
import Hero from "./components/Hero";
import HotBoard from "./components/HotBoard";
import ReversalStory from "./components/ReversalStory";
import EditorPicks from "./components/EditorPicks";
import CategoryStrip from "./components/CategoryStrip";
import Faq from "./components/Faq";
import About from "./components/About";
import Footer from "./components/Footer";

export default function Home() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "faq-schema";
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: FAQS.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    });
    document.head.appendChild(script);

    return () => {
      window.removeEventListener("scroll", onScroll);
      document.getElementById("faq-schema")?.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-paper-50 text-ink-900 antialiased">
      <Header />
      <main>
        <Hero />
        <HotBoard />
        <ReversalStory />
        <EditorPicks />
        <CategoryStrip />
        <Faq />
        <About />
      </main>
      <Footer />

      <button
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        aria-label="返回顶部"
        className={`fixed bottom-6 right-6 z-50 w-11 h-11 rounded-full bg-ink-900 text-paper-50 flex items-center justify-center shadow-soft hover:bg-brand-600 transition-all ${
          showTop ? "opacity-100 translate-y-0" : "opacity-0 pointer-events-none translate-y-3"
        }`}
      >
        <i className="ri-arrow-up-line text-lg" />
      </button>
    </div>
  );
}